import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { preRegistrationForm } from "./forms/PreRegistrationForm";
import { registrationForm } from "./forms/RegistrationForm";
import { abcdForm } from "./forms/ABCDForm";
import { hbcdForm } from "./forms/HBCDForm";
import { FormSchema } from "../../components/dynamicform/DynamicFormTypes";

const initialState = {
    forms : [preRegistrationForm, registrationForm, abcdForm, hbcdForm]
};



export const publicationSlice = createSlice({
    name: 'publication',
    initialState: initialState as any,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setFormStudy: (state, action: PayloadAction<any>) => {

            if(action.payload.length === 2){
                state.forms = [preRegistrationForm, registrationForm, abcdForm, hbcdForm]
            }
            else{
                if(action.payload[0] === 'abcd')
                {
                    const hbcdForm = makeNewFormStudy("HBCD")
                    state.forms = [preRegistrationForm, registrationForm, abcdForm, hbcdForm]
                }
                else{
                    const abcdForm = makeNewFormStudy("ABCD")
                    state.forms = [preRegistrationForm, registrationForm, abcdForm, hbcdForm]
                }
            }
        }
    }
});

const makeNewFormStudy = ((study: string) => {
    const Form: FormSchema = {
        title: study + " Information",
        fields: [
            {
                name: study + "Domains",
                type: "checkbox",
                label: study + "Domains",
                numColumns: 2,
                options: [
                    { label: "Culture & Environment", value: "Culture & Environment", disabled: true },
                    { label: "Novel Technologies", value: "Novel Technologies", disabled: true },
                    { label: "Gender & Sexuality", value: "Gender & Sexuality", disabled: true },
                    { label: "Physical Health", value: "Physical Health", disabled: true },
                    { label: "Genetics", value: "Genetics", disabled: true },
                    { label: "Substance Use", value: "Substance Use", disabled: true },
                    { label: "Imaging", value: "Imaging", disabled: true },
                    { label: "Substudy - COVID-19 (please also select any relevant domains above)", value: "Substudy - COVID-19", disabled: true },
                    { label: "Linked External Data", value: "Linked External Data", disabled: true },
                    { label: "Substudy - Endocannabinoid (please also select any relevant domains above)", value: "Substudy - Endocannabinoid", disabled: true },
                    { label: "Mental Health", value: "Mental Health", disabled: true },
                    { label: "Substudy - Hurricane Irma (please also select any relevant domains above)", value: "Substudy - Hurricane Irma", disabled: true },
                    { label: "Neurocognition", value: "Neurocognition", disabled: true },
                    { label: "Substudy - Social Development (please also select any relevant domains above)", value: "Substudy - Social Development", disabled: true },
                ]
            },
            {
                name: study + "ReleaseVersion",
                type: "radio",
                label: "Please select which release version you used for your publication?",
                options: [
                    { label: "4.0 (DOI Link)", value: "4.0 (DOI Link)", disabled: true },
                    { label: "5.0 (DOI Link)", value: "5.0 (DOI Link)", disabled: true },
                    { label: "5.1 (DOI Link)", value: "5.1 (DOI Link)", disabled: true },
                    { label: "6.0 (DOI Link)", value: "6.0 (DOI Link)", disabled: true },


                ]
            }
        ]
    };
    return Form;
})

export const { setFormStudy } = publicationSlice.actions;

export default publicationSlice.reducer;

export const selectForms = (state: any) => state.publication.forms;

